import type { HTMLAttributes } from "react"
import type { IStatusBadgeTypes } from "@/shared/ui/status-badges/types.ts"
import { cn } from "@/shared/utils"

export interface IStatusBadgeProps extends HTMLAttributes<HTMLDivElement> {
  label: string
  type: IStatusBadgeTypes
}

// #1DA081
// #1DA0811A

// #1D5EA0
// #1D5EA01A

// #661AD9
// #661AD91A

// #DC6803
// #DC68031A

// #03A6DC
// #03A6DC1A

// #0DAB0A
// #0DAB0A1A

export const stateTypes = {
  success: "success",
  warning: "warning",
  danger: "danger",
  info: "info",
  neutral: "neutral",
  active: "active",
  offline: "offline",
  pending: "pending",
  confirmed: "confirmed",
  accent: "accent"
}

const typeStyles: Record<IStatusBadgeTypes, string> = {
  success: "border-state-success-base bg-state-success-base-10 text-state-success-base",
  warning: "border-state-warning-base bg-state-warning-base-10 text-state-warning-base",
  danger: "border-state-danger-base bg-state-danger-base-10 text-state-danger-base",
  info: "border-state-info-base bg-state-info-base-10 text-state-info-base",
  neutral: "border-state-neutral-base bg-state-neutral-base-10 text-state-neutral-base",
  active: "border-state-active-base bg-state-active-base-10 text-state-active-base",
  offline: "border-state-offline-base bg-state-offline-base-10 text-state-offline-base",
  pending: "border-state-pending-base bg-state-pending-base-10 text-state-pending-base",
  confirmed: "border-state-confirmed-base bg-state-confirmed-base-10 text-state-confirmed-base",
  accent: "border-state-accent-base bg-state-accent-base-10 text-state-accent-base"
}

export function StatusBadge({ label, type, ...props }: IStatusBadgeProps) {
  return (
    <div
      {...props}
      className={cn(
        "flex h-[34px] select-none items-center justify-center text-nowrap rounded-lg border px-4 text-sm",
        typeStyles[type],
        props.className
      )}
    >
      {label}
    </div>
  )
}
